import useAuthHook from "@/shared/hooks/useAuthHook";
import useBranchId from "@/shared/hooks/useBranchId";
import usePrinterSettingsHook from "@/shared/hooks/usePrinterSettingsHook";
import { useSyncCashDroSettingsToDesktop } from "@/shared/hooks/useCashDroConfigHook";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

declare global {
  interface Window {
    electronAPI?: any;
    api?: any;
    process: {
      type: string;
    };
  }
}

const Electron = () => {
  const { t } = useTranslation("");
  const { isAuth } = useAuthHook();
  const { patchPrinters, getPrinterSettings } = usePrinterSettingsHook();
  const branch = useBranchId();
  useSyncCashDroSettingsToDesktop();

  useEffect(() => {
    branch && getPrinterSettings.refetch();
  }, [branch]);

  useEffect(() => {
    window.api.receive(
      "receiptStatusBack",
      (data: { orderId: number; printStatus: boolean; message: string }) => {
        if (data.printStatus) {
          toast.success(t("receiptHasBeenPrinted") + data.orderId, {
            toastId: `receipt-${data.orderId}`,
          });
        } else {
          toast.error(data.message);
        }
      }
    );
  }, []);

  useEffect(() => {
    if (isAuth && !patchPrinters.isPending) {
      window.api.receive("printers", (data: { printers: [] }) => {
        patchPrinters.mutateAsync(
          { printers: data.printers },
          {
            onSuccess: () => {
              getPrinterSettings.refetch();
            },
          }
        );
      });
    }
  }, [isAuth]);

  return <></>;
};

export default Electron;
